import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon } from 'lucide-react';
export function CostOfInaction() {
  const costs = [{
    problem: 'Recetas de YouTube que no te quedan igual',
    cost: 'Ingredientes tirados, plata perdida'
  }, {
    problem: 'Sin fórmula de precios',
    cost: 'Trabajás horas y no ganás nada'
  }, {
    problem: 'Packaging armado con lo que tenés',
    cost: 'Vergüenza de mostrar el producto'
  }, {
    problem: 'Sin sistema de redes',
    cost: 'Nunca llegás a nuevos clientes'
  }, {
    problem: 'Sin las recetas Sin TACC',
    cost: 'Perdés un mercado enorme'
  }, {
    problem: 'Otro fin de semana sin vender nada',
    cost: 'El mismo ciclo, el mes que viene'
  }];
  return <section className="w-full bg-[#FBF5EC] donut-pattern py-4 md:py-8" data-id="element-40">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <div className="text-center mb-3 md:mb-6" data-id="element-43">
            <div className="flex justify-center mb-2 md:mb-3" data-id="element-44">
              <div className="bg-[#B85450]/10 p-3 rounded-full" data-id="element-45">
                <ScaleIcon className="w-10 h-10 text-[#B85450]" data-id="element-46" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#3D2817] mb-1 md:mb-2" data-id="element-47">
              ⚖️ ¿CUÁNTO TE CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-white border border-[#E8D5BA] rounded-lg overflow-hidden mb-3 md:mb-5 shadow-sm" data-id="element-48">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 bg-[#FAF1E4] border-b border-[#E8D5BA]" data-id="element-49">
              <div className="font-bold text-[#3D2817] text-sm" data-id="element-50">
                Sin el Mega Pack
              </div>
              <div className="font-bold text-[#B85450] text-sm" data-id="element-51">Costo real</div>
            </div>

            {costs.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 border-b border-[#F0E3CE] last:border-b-0" data-id="element-52">
                <div className="text-[#6B5747] text-sm" data-id="element-53">{item.problem}</div>
                <div className="text-[#B85450] font-semibold text-sm" data-id="element-54">
                  {item.cost}
                </div>
              </motion.div>)}
          </div>

          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-[#B45309] text-center" data-id="element-55">
            La próxima semana puede ser diferente.
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}